import DropDown from '../../../../shared/components/DropDown'
import { DateFilter } from './DateFilter'
import { 
  STATUS_OPTIONS, 
  PAYMENT_OPTIONS, 
  type FilterOption,
  type FilterState,
  type DatePreset,
  type DateMode,
} from '../../types/filters.types'

interface FilterSectionProps {
  filters: FilterState
  onFilterChange: (filters: Partial<FilterState>) => void
  onClearFilters: () => void
  categoryOptions: FilterOption[]
}

export const FilterSection = ({
  filters,
  onFilterChange,
  onClearFilters,
  categoryOptions
}: FilterSectionProps) => {

  const handleStatusChange = (value: string) => {
    onFilterChange({ status: value })
  }

  const handlePaymentChange = (value: string) => {
    onFilterChange({ payment: value })
  }

  const handleCategoryChange = (value: string) => {
    onFilterChange({ category: value })
  }

  const handleDateModeChange = (mode: DateMode) => {
    onFilterChange({ dateMode: mode })
  }

  const handleDatePresetChange = (preset: DatePreset) => {
    onFilterChange({ datePreset: preset })
  }

  const handleDateRangeChange = (range: { start: Date; end: Date }) => {
    onFilterChange({ dateRange: range })
  }

  const handleSelectedDatesChange = (dates: Date[]) => {
    onFilterChange({ selectedDates: dates })
  }

  const isStatusActive = filters.status !== 'All Status'
  const isPaymentActive = filters.payment !== 'All Payments' 
  const isCategoryActive = filters.category !== 'All Categories'

  return (
    <div className="w-full max-w-[1007px] flex flex-wrap lg:flex-nowrap justify-between items-center gap-3 lg:gap-0">
      <div className="flex items-center gap-4">
        <DropDown
          options={STATUS_OPTIONS}
          value={filters.status}
          onChange={handleStatusChange}
          placeholder="All Status"
          isActive={isStatusActive}
          size="large"
        />
        
        <DropDown
          options={PAYMENT_OPTIONS}
          value={filters.payment}
          onChange={handlePaymentChange}
          placeholder="All Payments"
          isActive={isPaymentActive}
          size="large"
        />
        
        <DropDown
          options={categoryOptions}
          value={filters.category}
          onChange={handleCategoryChange}
          placeholder="All Categories"
          isActive={isCategoryActive}
          size="large"
        />

        <DateFilter
          dateMode={filters.dateMode}
          datePreset={filters.datePreset}
          dateRange={filters.dateRange}
          selectedDates={filters.selectedDates}
          onDateModeChange={handleDateModeChange}
          onDatePresetChange={handleDatePresetChange}
          onDateRangeChange={handleDateRangeChange}
          onSelectedDatesChange={handleSelectedDatesChange}
        />
      </div>
      
      <button
        onClick={onClearFilters}
        className="text-red-600 border border-red-300 hover:bg-red-50 px-4 py-2 rounded-lg transition-colors"
      >
        Clear Filters
      </button>
    </div>
  )
}